import { render } from "./TlbsOfferAlumniPifComponent.vue?vue&type=template&id=52a67835&ts=true"
import script from "./TlbsOfferAlumniPifComponent.vue?vue&type=script&lang=ts"
export * from "./TlbsOfferAlumniPifComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__